import callApi, { METHOD_TYPE } from '../utils/callApi'
import { DECISIONTREE } from '../mutations'
import { cloneDeep } from 'lodash'
import { decisiontreeFormat } from '../constants'

// 代入される雛形
const state = {
  decisiontree: {},
  decisiontreelist: [],
  datasourceInList: [],
  datasourceId: ''
}

const mutations = {
  [DECISIONTREE.DECISIONTREE_LIST](state, payload) { state.decisiontreelist = payload },
  [DECISIONTREE.DECISIONTREE_GET](state, payload) {
    state.decisiontree.datasourceId = payload.datasourceId
    state.decisiontree.treeId = payload.treeId
    state.decisiontree.versionId = payload.versionId
    state.decisiontree.name = payload.metadata.name
    state.decisiontree.downloadUrl = payload.downloadUrl
    state.decisiontree.model = payload.model
  },
  [DECISIONTREE.DATASOURCE_LIST](state, payload) {
    state.datasourceInList = payload
  }
}

const actions = {
  getDatasourceInListData({ commit }) {
    callApi('/udata/list-datasource', METHOD_TYPE.POST, { })
    .then((response) => {
      commit(DECISIONTREE.DATASOURCE_LIST, response.body.datasourceInList)
    })
  },
  getDecisiontreeListData({ commit }, datasourceId) {
    callApi('/udata/list-decision-tree', METHOD_TYPE.POST, { 'datasourceId': datasourceId, 'consistentRead': true })
    .then((response) => {
      commit(DECISIONTREE.DECISIONTREE_LIST, response.body.decisionTrees)
    })
    .catch(e => {
      if (e.response == null) {
        alert('決定木の取得に失敗しました。' + '\n' + e.message)
      } else {
        location.href = '#/error/' + e.status
        alert('決定木の取得に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message)
      }
    })
  },
  getDecisiontreeData({ commit }) {
    callApi('/udata/get-decision-tree', METHOD_TYPE.POST, { 'datasourceId': state.decisiontree.datasourceId, 'treeId': state.decisiontree.treeId, 'consistentRead': true })
    .then((response) => {
      commit(DECISIONTREE.DECISIONTREE_GET, response.body.decisionTree)
    })
    .catch(e => {
      this.errors.push(e)
    })
  },
  formatDecisionTreeData({ commit }) {
    commit(DECISIONTREE.DECISIONTREE_GET, cloneDeep(decisiontreeFormat))
  },
  createDecisionTree({ commit }, router) {
    let createparams = state.decisiontree
    callApi('/udata/create-decision-tree', METHOD_TYPE.POST, createparams)
    .then((response) => {
      alert('決定木の作成に成功しました')
      router.push('/udata/list-decision-tree')
    })
    .catch(e => {
      if (e.response == null) {
        alert('決定木の作成に失敗しました。' + '\n' + e.message)
      } else {
        alert('決定木の作成に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message)
      }
    })
  },
  updateDecisionTree({ commit }, router) {
    let updateparams = state.decisiontree
    callApi('/udata/update-decision-tree', METHOD_TYPE.POST, updateparams)
    .then((response) => {
      alert('決定木の更新に成功しました')
      router.push('/udata/list-decision-tree')
    })
    .catch(e => {
      if (e.response == null) {
        alert('決定木の更新に失敗しました。' + '\n' + e.message)
      } else {
        alert('決定木の更新に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message)
      }
    })
  },
  decisionTreeDelete({ commit }, decisionTree) {
    callApi('/udata/delete-decision-tree', METHOD_TYPE.POST, { datasourceId: decisionTree.datasourceId, treeId: decisionTree.treeId, versionId: decisionTree.versionId })
    .then((response) => {
      commit(DECISIONTREE.DECISIONTREE_LIST, state.decisiontreelist.filter(n => n !== decisionTree))
    })
    .catch(e => {
      if (e.response == null) {
        alert('決定木の削除に失敗しました。' + '\n' + e.message)
      } else {
        location.href = '#/error/' + e.status
        alert('決定木の削除に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message)
      }
    })
  }
}

export default {state, actions, mutations}



// WEBPACK FOOTER //
// ./src/stores/decisiontree.js